var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.371 4.629H1.467V1.467h7.904zM7 12.533a2.37 2.37 0 0 1-2.371-2.371A2.37 2.37 0 0 1 7 7.79a2.37 2.37 0 0 1 2.371 2.372A2.37 2.37 0 0 1 7 12.532zM10.952-.114H1.467a1.58 1.58 0 0 0-1.58 1.581v11.066c0 .87.703 1.58 1.58 1.58h11.066c.87 0 1.58-.71 1.58-1.58V3.048z"
  })));
};
export default SvgSave;